import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

interface MastercardLogoProps extends IconProps {
  theme?: 'phthalo' | 'grayscale' | 'greenfit'
}

export const MastercardLogo: FC<MastercardLogoProps> = (props) => {
  const themeColors = (theme?: string) => {
    if (!theme) {
      return ['#F79E1B', '#EB001A', '#FF5B01']
    }
    return theme === 'phthalo'
      ? ['#ADEDD6', '#235E64', '#368081']
      : theme === 'greenfit'
      ? ['#B1F3A7', '#264021', '#1B2D18']
      : ['#939393', '#5A5A5A', '#B7B7B7']
  }

  return (
    <Icon xmlSpace="preserve" viewBox="0 0 74.3 46.6" width="74px" height="46px" {...props}>
      <path d="M47 5.6H27.3V41H47V5.6z" fill={themeColors(props.theme)[2]} />
      <path
        d="M28.5 23.3c0-3.4.8-6.8 2.3-9.8 1.5-3.1 3.7-5.8 6.4-7.9C33.8 3 29.8 1.4 25.6.9c-4.2-.5-8.5.3-12.3 2.1-3.8 1.8-7 4.7-9.3 8.3C1.8 15 .6 19.1.6 23.3S1.8 31.7 4 35.2c2.2 3.6 5.5 6.5 9.3 8.3 3.8 1.8 8.1 2.6 12.3 2.1 4.2-.5 8.2-2.1 11.5-4.7-2.7-2.1-4.9-4.8-6.4-7.9-1.4-2.9-2.2-6.3-2.2-9.7z"
        fill={themeColors(props.theme)[1]}
      />
      <path
        d="M73.6 23.3c0 4.2-1.2 8.4-3.4 11.9-2.2 3.6-5.5 6.5-9.3 8.3-3.8 1.8-8.1 2.6-12.3 2.1-4.2-.5-8.2-2.1-11.5-4.7 2.7-2.1 4.9-4.8 6.3-7.9 1.5-3.1 2.3-6.4 2.3-9.8s-.8-6.8-2.3-9.8c-1.5-3.1-3.7-5.8-6.3-7.9 3.3-2.6 7.3-4.2 11.5-4.7s8.5.3 12.3 2.1c3.8 1.8 7 4.7 9.3 8.3 2.2 3.8 3.4 7.9 3.4 12.1z"
        fill={themeColors(props.theme)[0]}
      />
    </Icon>
  )
}
